import DeleteButton from "components/atoms/buttons/DeleteButton/DeleteButton";
import { CardContainer, CardInfo } from "./CommonRowCard.style";

interface CommonRowCardProps {
  title: string;
  handleClick: () => void;
  handleDeleteClick: () => void;
}

const CommonRowCard = ({
  title,
  handleClick,
  handleDeleteClick,
}: CommonRowCardProps) => {
  return (
    <CardContainer>
      <CardInfo onClick={handleClick}>
        <h2>{title}</h2>
      </CardInfo>
      <DeleteButton handleClick={handleDeleteClick} />
    </CardContainer>
  );
};

export default CommonRowCard;
